import {useStepperPaths} from 'hooks/useStepperPaths'
import {useActivityPath, useMoreToursPath, usePaymentPath, useTravelerPath} from 'providers/EnvironmentProvider'
import {useNavigationHistory} from 'providers/OrderDetailsProvider'
import {useMemo} from 'react'
import {Step} from './Step'

const getMaxStepIndex = (navigationHistory: string[], paths: string[]) => {
  for (let i = paths.length - 1; i > -1; i--) {
    const path = paths[i]

    for (const location of navigationHistory) {
      const locationPath = new URL(location).pathname

      if (locationPath === path) {
        return i
      }
    }
  }

  return -1
}

export const Stepper = () => {
  const paymentPath = usePaymentPath()
  const activityPath = useActivityPath()
  const moreToursPath = useMoreToursPath()
  const travelerPath = useTravelerPath()

  const stepperPaths = useStepperPaths()
  const navigationHistory = useNavigationHistory()

  const names = useMemo(
    () => ({
      [travelerPath]: 'Traveler',
      [activityPath]: 'Activity',
      [moreToursPath]: 'More tours',
      [paymentPath]: 'Payment',
    }),
    [travelerPath, activityPath, moreToursPath, paymentPath]
  )

  const currentStepIndex = stepperPaths.findIndex((path) => path === window.location.pathname)
  const maxStepIndex = getMaxStepIndex(navigationHistory, stepperPaths)

  return (
    <div className="flex w-full gap-2 py-6">
      {stepperPaths.map((path, i) => {
        return (
          <Step
            key={i}
            active={i === currentStepIndex}
            enabled={maxStepIndex > -1 && i <= maxStepIndex}
            completed={maxStepIndex > -1 && i < maxStepIndex}
            index={i + 1}
            name={names[path]}
            path={path}
          />
        )
      })}
    </div>
  )
}
